import React from "react";
import { mockup } from "../data/content";
type ProductMockupProps = {
  size?: "sm" | "md" | "lg";
  eager?: boolean;
  className?: string;
};
const widths = {
  sm: "max-w-[240px] sm:max-w-[300px]",
  md: "max-w-[270px] sm:max-w-[340px]",
  lg: "max-w-[290px] sm:max-w-[420px]"
};
export function ProductMockup({
  size = "md",
  eager = false,
  className = ""
}: ProductMockupProps) {
  return <div className={`relative mx-auto w-full ${widths[size]} ${className}`} data-id="element-183" data-mp="3h9vcaibp6spn">
      <div aria-hidden="true" className="absolute inset-[-10%] rounded-full bg-[radial-gradient(closest-side,rgba(242,196,107,0.38),rgba(47,107,255,0.18)_55%,transparent_78%)] blur-2xl" data-id="element-184" data-mp="3ca908c7lviif" />
      <div aria-hidden="true" className="absolute bottom-[1%] left-1/2 h-[7%] w-[60%] -translate-x-1/2 rounded-[50%] bg-black/50 blur-xl" data-id="element-185" data-mp="37cz1u728nwig" />
      <img src={mockup.src} alt={mockup.alt} loading={eager ? "eager" : "lazy"} className="animate-float relative w-full" data-id="element-186" data-mp="1vw931905a6yv" />
    </div>;
}